import {
  Box,
  Dropdown,
  Heading,
  RadioGroup,
  RadioItem,
  Stack,
  Text,
  TextField,
} from 'braid-design-system';
import { useFormContext } from 'react-hook-form';

import { LargestCustomers } from '../LargestCustomers';

export const BusinessDetails = () => {
  const {
    register,
    formState: { errors },
    watch,
    setValue,
    trigger,
  } = useFormContext();

  return (
    <Stack space="medium">
      <Box paddingTop="gutter">
        <Stack space="small">
          <Heading level="3">Business details</Heading>
          <Text>
            If you are making this request on behalf of another company, please
            share their details.
          </Text>
        </Stack>
      </Box>
      <TextField
        id="company"
        label="Company name"
        onClear={() => setValue('company', '')}
        message={errors.company?.message as string}
        tone={Boolean(errors.company) ? 'critical' : 'neutral'}
        {...register('company')}
        value={watch('company')}
      />
      <TextField
        id="companyUrl"
        label="Company URL"
        onClear={() => setValue('company', '')}
        message={errors.companyUrl?.message as string}
        tone={Boolean(errors.companyUrl) ? 'critical' : 'neutral'}
        {...register('companyUrl')}
        value={watch('companyUrl')}
      />
      <TextField
        id="companyLocation"
        label="Company Location"
        onClear={() => setValue('company', '')}
        message={errors.companyLocation?.message as string}
        tone={Boolean(errors.companyLocation) ? 'critical' : 'neutral'}
        {...register('companyLocation')}
        value={watch('companyLocation')}
      />

      <Stack space="xsmall">
        <Dropdown
          id="platformType"
          label="Platform type"
          {...register('platformType')}
          value={watch('platformType')}
          tone={Boolean(errors.platformType) ? 'critical' : 'neutral'}
          placeholder="Select your primary offering"
          message={errors.platformType?.message as string}
        >
          <option>ATS</option>
          <option>CRM</option>
          <option>HRIS</option>
          <option>Job Distributor</option>
          <option>SEEK Customer</option>
          <option>Chat bot</option>
          <option>Other</option>
        </Dropdown>

        {watch('platformType') === 'Other' && (
          <TextField
            id="platformTypeOther"
            aria-label="Platform Type for Other field"
            placeholder="E.g. Connector"
            onClear={() => setValue('platformTypeOther', '')}
            message={errors.platformTypeOther?.message as string}
            tone={Boolean(errors.platformTypeOther) ? 'critical' : 'neutral'}
            {...register('platformTypeOther')}
            value={watch('platformTypeOther') || ''}
          />
        )}
      </Stack>

      <RadioGroup
        label="Are you a recruitment software provider wanting to integrate to SEEK?"
        id="seekRsp"
        onChange={({ currentTarget: { value } }) => {
          if (value === 'yes') {
            setValue('company', '');
          }
          setValue('seekRsp', value as 'yes' | 'no');
          register('seekRsp').onChange({ target: { value } });
        }}
        value={watch('seekRsp') || 'yes'}
      >
        <RadioItem label="Yes" value="yes" />
        <RadioItem label="No" value="no" />
      </RadioGroup>
      {watch('seekRsp') === 'no' && (
        <TextField
          id="recruitmentSoftware"
          label="What recruitment software do you use?"
          onClear={() => setValue('recruitmentSoftware', '')}
          message={errors.recruitmentSoftware?.message as string}
          tone={Boolean(errors.recruitmentSoftware) ? 'critical' : 'neutral'}
          {...register('recruitmentSoftware')}
          value={watch('recruitmentSoftware') || ''}
        />
      )}
      {watch('seekRsp') === 'yes' && (
        <>
          <TextField
            id="customerSegment"
            label="What customer segment are you primarily serving?"
            onClear={() => setValue('customerSegment', '')}
            message={errors.customerSegment?.message as string}
            tone={Boolean(errors.customerSegment) ? 'critical' : 'neutral'}
            {...register('customerSegment')}
            value={watch('customerSegment') || ''}
          />
          <TextField
            id="numCustomers"
            label="How many SEEK customers do you have?"
            onClear={() => setValue('numCustomers', '')}
            message={errors.numCustomers?.message as string}
            tone={Boolean(errors.numCustomers) ? 'critical' : 'neutral'}
            type="number"
            {...register('numCustomers')}
            value={watch('numCustomers')}
          />
          {Number(watch('numCustomers')) > 0 && (
            <LargestCustomers
              customersLength={Number(watch('numCustomers'))}
              error={Boolean(errors.largestCustomers)}
              id="largestCustomers"
              // No need to pass ref here
              rawValue={watch('largestCustomers') || ''}
              onChange={(value) => {
                setValue('largestCustomers', value);
                register('largestCustomers').onChange({ target: { value } });
                trigger('largestCustomers');
              }}
            />
          )}
          <TextField
            id="jobAds"
            label="What is the total number of job ads estimated per year?"
            onClear={() => setValue('jobAds', '')}
            message={errors.jobAds?.message as string}
            tone={Boolean(errors.jobAds) ? 'critical' : 'neutral'}
            {...register('jobAds')}
            value={watch('jobAds') || ''}
          />
        </>
      )}
    </Stack>
  );
};
